module.exports = __webpack_public_path__ + "img/114.447341d1.jpg";